import React from 'react';
import Typography from '@material-ui/core/Typography';
import LockIcon from '@material-ui/icons/Lock';

export default function NoAccess() {
  return (
    <div style={{ borderRadius: 8, color: 'grey', width: 400, padding: 24, margin: '0 auto', marginTop: '24px', textAlign: 'center' }}>
      <LockIcon style={{ fontSize: 190 }} />
      <Typography style={{ fontSize: 24 }}>
        You don't have access to this page.
      </Typography>
    </div>
  );
}
